





import { PAGE_NS, PageState } from '~/store/modules/shared/page/state'
import { ConsentName } from '~/models/shared/types'
import Over18Prompt from '~/components/shared/consent/Over18Prompt.vue'
import { computed, defineComponent } from '@nuxtjs/composition-api'
import { useNamespacedStore } from '~/compositions/store'

export default defineComponent({
  components: { Over18Prompt },
  setup() {
    const { state } = useNamespacedStore<PageState>(PAGE_NS)

    const consent = computed(() => state.consent)
    const promptComponent = computed(() => {
      switch (consent.value?.name) {
        case ConsentName.OVER18: {
          return Over18Prompt
        }
        default: {
          return null
        }
      }
    })

    return { promptComponent }
  }
})
